<template>
    <form class="card">
        <h3>Информация</h3>
        <ParkingConfig :data.sync="data.booking"></ParkingConfig>
    </form>
</template>

<script>
    import ParkingConfig from '@/components/forms/ParkingConfig.vue'

    export default {
        props: ['data'],
        components: {
            ParkingConfig
        }
    }
</script>